import { MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PICKUP_LOCATIONS } from "../../data/experiences";
import Reveal from "../Reveal";

export default function PickupLocations() {
  const { t } = useTranslation();
  return (
    <section className="bg-bone py-24 lg:py-40" data-testid="pickup-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-16 lg:mb-20">
          <div className="md:col-span-8">
            <div className="text-xs uppercase tracking-wider-3 text-moss mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-moss" />
              {t("pickup.eyebrow")}
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-forest leading-[1.04]">
              {t("pickup.title_a")}<br/><span className="italic">{t("pickup.title_b")}</span>
            </h2>
          </div>
          <div className="md:col-span-4 text-muted-foreground text-sm leading-relaxed md:pb-3">
            {t("pickup.subtitle")}
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-bone-deep border border-bone-deep">
          {PICKUP_LOCATIONS.map((loc, i) => (
            <Reveal key={loc} delay={i * 120} className="bg-bone p-10 lg:p-12 group hover:bg-forest hover:text-bone transition-colors duration-700">
              <div className="flex items-start justify-between">
                <MapPin className="w-6 h-6 text-forest group-hover:text-bone stroke-[1.25]" />
                <span className="text-xs uppercase tracking-wider-3 text-moss group-hover:text-bone/60">0{i+1}</span>
              </div>
              <h3 className="font-display text-4xl mt-10 text-forest group-hover:text-bone">{loc}</h3>
              <p className="mt-4 text-sm text-muted-foreground group-hover:text-bone/80 leading-relaxed">
                {t(`pickup.details.${loc}`)}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
